import LangEnum from '../../../../../lang/LangEnum';
import { CatalogSectionSortCriterionEnum } from '../../../enums/catalogSectionSortCriterion.enum';
import { CatalogCardVariantKey } from '../sizing/catalogCardColumns.types';

export enum CatalogViewMode {
  LIST = 'list',
  CARD = 'card',
}

export enum CatalogViewGroupBy {
  MANUAL = 'MANUAL',
  COLLECTION = 'COLLECTION',
  CATEGORY = 'CATEGORY',
  SUBCATEGORY = 'SUBCATEGORY',
  CLASSIFICATION_TYPE = 'CLASSIFICATION_TYPE',
}

export interface CatalogViewUserFields {
  mode: CatalogViewMode;
  cardSize: CatalogCardVariantKey;
  groupBy: CatalogViewGroupBy;
  groupTargetId: string | null;
  sortCriterion: CatalogSectionSortCriterionEnum;
  sortTargetId: string | null;
}

export type CatalogViewCatalogFields = CatalogViewUserFields;

export interface CatalogViewDraft extends CatalogViewCatalogFields {
  isRestorePending: boolean;
}

export type CatalogViewUserPreference = Partial<CatalogViewUserFields>;

export type CatalogViewUserField = keyof CatalogViewUserFields;
export type CatalogViewCatalogField = keyof CatalogViewCatalogFields;

export interface CatalogViewOption<T> {
  value: T;
  label: LangEnum;
  isDisabled?: boolean;
  blockedReason?: LangEnum;
}

export interface CatalogViewCombination {
  sortCriterion: CatalogSectionSortCriterionEnum;
  groupBy: CatalogViewGroupBy;
}

export interface GetIsFreezeToManualParams {
  configSnapshot: CatalogViewCatalogFields;
  dirtyForAll: CatalogViewCatalogField[];
  draft: CatalogViewDraft;
}

export interface IsMaterializeGroupingParams {
  configSnapshot: CatalogViewCatalogFields;
  dirtyForAll: CatalogViewCatalogField[];
  draft: CatalogViewDraft;
}

export interface IsFreezingArrangementParams {
  configSnapshot: CatalogViewCatalogFields | null;
  dirtyForAll: CatalogViewCatalogField[];
  draft: CatalogViewDraft | null;
}

export interface ResolveNotGroupedWarningParams {
  catalogConfig: CatalogViewCatalogFields | null;
  isManualGroupingCriterion: boolean;
  isPending: boolean;
}

export type NotGroupedWarning = LangEnum;
